import { LogLevel } from 'tradingmate-modules/src/debug/Logger'
import { IConfig } from 'tradingmate-modules/src/environment'
import HttpProviderType from 'tradingmate-modules/src/services/httpclient/HttpProviderType'

// Old
// export default {
//   Http: {
//     Provider: HttpProviderType.Fetch
//   },
//   API: {
//     // Development
//     Base: 'https://localhost:44300'

//     // Staging
//     // Base: 'https://api.staging.tradingmate.com.au'

//     // Production
//     // Base: 'https://api.tradingmate.com.au'
//   },
//   WebsiteUrls: {
//     // Development
//     Public: 'http://localhost:8080',
//     Console: 'http://localhost:8081',
//     Cdn: 'http://cdn.dev.tradingmate.com.au'

//     // Staging
//     // Public: 'https://www.staging.tradingmate.com.au',
//     // Console: 'https://my.staging.tradingmate.com.au',
//     // Cdn: 'https://cdn.tradingmate.com.au'

//     // Production
//     // Public: 'https://www.tradingmate.com.au',
//     // Console: 'https://my.tradingmate.com.au',
//     // Cdn: 'https://cdn.tradingmate.com.au'

//     // Pre-rollover test
//     // Public: 'https://www.prod.tradingmate.com.au',
//     // Console: 'https://my.tradingmate.com.au',
//     // Cdn: 'https://cdn.tradingmate.com.au'
//   },
//   Logging: {
//     LogLevel: LogLevel.Debug
//   },
//   OAuth: {
//     // dev
//     ConsumerId: 'd9b328d9-70e1-4ac9-abdc-7262daefb937'

//     // live
//     // ConsumerId: '9654d63c-b6a7-48c7-a27f-5ad730fab99a'
//   }
// } as IConfig

// Local
// export default {
//   Http: {
//     Provider: HttpProviderType.Fetch
//   },
//   API: {
//     // Development
//     Base: 'https://localhost:44300'
//   },
//   WebsiteUrls: {
//     // Development
//     Public: 'http://localhost:8080',
//     Console: 'http://localhost:8081',
//     Cdn: 'http://cdn.dev.tradingmate.com.au'
//   },
//   Logging: {
//     LogLevel: LogLevel.Debug
//   },
//   OAuth: {
//     // dev
//     ConsumerId: 'd9b328d9-70e1-4ac9-abdc-7262daefb937'
//   }
// } as IConfig

// Production
export default {
  Http: {
    Provider: HttpProviderType.Fetch
  },
  API: {
    // Production
    Base: 'https://api.tradingmate.com.au'
  },
  WebsiteUrls: {
    // Production
    Public: 'https://www.tradingmate.com.au',
    Console: 'https://my.tradingmate.com.au',
    Cdn: 'https://cdn.tradingmate.com.au'
  },
  Logging: {
    LogLevel: LogLevel.Debug
  },
  OAuth: {
    // live
    ConsumerId: '9654d63c-b6a7-48c7-a27f-5ad730fab99a'
  }
} as IConfig
